import type { PaymentDirection } from '@cpce/database/enums';
import type { FinancialAccountsFilters } from '@cpce/shared';
import { queryKeysBuilder } from '@/api/queries.utils';

const builder = queryKeysBuilder(['financial-accounts']);

export const financialAccountsQueryKeys = {
  all: builder(),
  filtered: (filters: FinancialAccountsFilters) => builder('filtered', filters),
  one: (id: number) => builder('one', id),
  nextCode: (parentId: number) => builder('next-code', parentId),
  bankAccounts: (direction: PaymentDirection) => builder('bank-accounts', direction),
  count: () => builder('count'),
  options: () => builder('options'),
  connectableClientAccounts: () => builder('connectable-client-accounts'),
  clientAccountNextCode: () => builder('client-account-next-code'),
  unusedClientAccountsCount: () => builder('unused-client-accounts-count'),
  missingClientAccountsCount: () => builder('missing-client-accounts-count'),
  connectableSupplierAccounts: () => builder('connectable-supplier-accounts'),
  supplierAccountNextCode: () => builder('supplier-account-next-code'),
};
